import { render, staticRenderFns } from "./PfCreate.vue?vue&type=template&id=9c35c518&"
import script from "./PfCreate.vue?vue&type=script&lang=js&"
export * from "./PfCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports